module.exports = __webpack_public_path__ + "img/method.8d20a1e0.svg";